"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { ArrowRight, Calendar } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
function NewsCarouselConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="flex gap-6 overflow-hidden">
        {[...Array(3)].map((_, i) => <div key={i} className="h-[300px] w-full shrink-0 animate-pulse rounded-xl bg-muted/20 md:w-1/3" />)}
      </div>;
  }
  if (error) {
    return <div className="text-destructive">Failed to load news.</div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-muted-foreground">No news available at the moment.</div>;
  }
  return <Carousel opts={{
    align: "start",
    loop: true
  }} className="w-full">
      <CarouselContent className="-ml-4 md:-ml-6">
        {posts.map((post, i) => <CarouselItem key={post.id} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3" data-index={i}>
            <Link to={post.link || "#"} className="group block h-full">
              <Card className="h-full border-none bg-transparent transition-colors hover:bg-muted/30">
                <CardContent className="flex h-full flex-col justify-between p-6">
                  <div className="space-y-4">
                    {}
                    <div className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-[var(--color-chart-2)]">
                      <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
                      <time dateTime={post.date}>
                        {post.date ? new Date(post.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                    }) : "Recent"}
                      </time>
                    </div>

                    {}
                    <h3 className="font-sans text-xl font-bold leading-snug text-[var(--color-primary)] group-hover:underline group-hover:decoration-[var(--color-chart-2)] group-hover:underline-offset-4 md:text-2xl">
                      {post.title}
                    </h3>

                    {post.excerpt && <div className="line-clamp-3 text-muted-foreground" dangerouslySetInnerHTML={{
                  __html: post.excerpt
                }} />}
                  </div>

                  <div className="mt-6 flex items-center text-sm font-semibold text-[var(--color-primary)]">
                    Read More <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          </CarouselItem>)}
      </CarouselContent>
      
      {}
      <div className="mt-8 flex justify-end gap-2 pr-4 md:hidden">
        <CarouselPrevious className="static translate-y-0" />
        <CarouselNext className="static translate-y-0" />
      </div>
      <div className="hidden md:block">
        <CarouselPrevious className="-left-4 lg:-left-12" />
        <CarouselNext className="-right-4 lg:-right-12" />
      </div>
    </Carousel>;
}
export default function NewsCenter() {
  const wp_query_params = {
    per_page: 9,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="trung-tâm-tin-tức" className="relative bg-[linear-gradient(to_bottom,var(--color-background)_0%,var(--color-background)_70%,var(--color-accent)/5_100%)] py-16 md:py-24">
      <div className="container mx-auto px-4">
        {}
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-sans text-3xl font-bold tracking-tight text-[var(--color-primary)] md:text-4xl lg:text-5xl">Tin Tức Mới Nhất</h2>
            <p className="mt-4 text-lg text-muted-foreground">
              Cập nhật những công nghệ xây dựng, dự án và hoạt động nghiên cứu mới nhất từ NUCETECH.
            </p>
          </div>
          
          <Link to="/NewsPage">
            <Button variant="outline" className="group border-[var(--color-primary)] text-[var(--color-primary)] hover:bg-[var(--color-primary)] hover:text-white">Tất cả Tin Tức<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/NewsCenter.tsx|sig:w2xrao" data-ast-start="4669" data-ast-end="4754"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>
          </Link>
        </div>

        <div className="mb-12 h-px w-full bg-border/60" />

        {}
        <PostsProvider wp_query={{
        per_page: 9,
        orderby: "date",
        order: "desc"
      }} className="relative">
          <NewsCarouselConsumer />
        </PostsProvider>
      </div>
    </section>;
}